export const OBJECTSDATA_URL = `${process.env.REACT_APP_API_URL}/objectsData`;
export const RUNDOWN_URL = `${process.env.REACT_APP_URL}/module/RUND/api`;